import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'Mateo Giménez',
  age: 22,
  city: 'Rosario',
  text: 'Jugué de 5 toda la vida pero recién con este manual entendí cómo leer el partido antes de recibir. Mi entrenador notó el cambio en 3 semanas.'
}, {
  name: 'Lucas Romero',
  age: 28,
  city: 'Córdoba',
  text: 'Los capítulos de coberturas y presión tras pérdida me cambiaron la cabeza. Ahora corro menos y llego mejor.'
}, {
  name: 'Tomás Acuña',
  age: 19,
  city: 'La Plata',
  text: 'Soy jugador de reserva y me sirvió un montón. El plan de 8 semanas es oro puro.'
}, {
  name: 'Federico Sosa',
  age: 31,
  city: 'Mendoza',
  text: 'Después de los 30 pensé que ya no podía mejorar. Este libro me demostró lo contrario. Jugar como 5 ahora es disfrutar.'
}, {
  name: 'Bruno Maidana',
  age: 24,
  city: 'Mar del Plata',
  text: 'Lo recomiendo a cualquier mediocampista. La parte de duelos y faltas tácticas es brutal.'
}];
export function Testimonials() {
  return <section className="py-20 px-4 bg-brand-surface" data-id="element-176">
      <div className="max-w-6xl mx-auto" data-id="element-177">
        <div className="text-center mb-16" data-id="element-178">
          <h2 className="font-display text-4xl md:text-6xl tracking-wide text-brand-text" data-id="element-179">
            LO QUE DICEN LOS <span className="text-brand-green" data-id="element-180">JUGADORES</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-181">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className={`bg-white p-6 rounded-xl border border-brand-border shadow-sm hover:shadow-md transition-shadow ${index === 4 ? 'md:col-span-2 lg:col-span-1 lg:col-start-2' : ''}`} data-id="element-182">
              <div className="flex items-center gap-4 mb-4" data-id="element-183">
                <div className="w-12 h-12 rounded-full bg-brand-green flex items-center justify-center text-white font-bold text-xl" data-id="element-184">
                  {t.name.charAt(0)}
                </div>
                <div data-id="element-185">
                  <h4 className="font-bold text-brand-text" data-id="element-186">{t.name}</h4>
                  <p className="text-sm text-brand-muted" data-id="element-187">
                    {t.age} años • {t.city}
                  </p>
                </div>
              </div>
              <div className="flex gap-1 mb-3" data-id="element-188">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-brand-green text-brand-green" data-id="element-189" />)}
              </div>
              <p className="text-brand-muted italic" data-id="element-190">"{t.text}"</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}